import { BaseFilter } from "@searchkit/sdk";
import { ValueFilter } from "@searchkit/sdk/lib/cjs/core/QueryManager";

interface TermFilterConfig {
  identifier: string;
  field: string;
  label: string;
  display?: "TermFilter" | string;
}

class ExistFilter implements BaseFilter {
  constructor(private config: TermFilterConfig) {}

  getIdentifier(): string {
    return this.config.identifier;
  }

  getLabel(): string {
    return this.config.label;
  }

  getFilters(filters: any) {
    return filters[0].value === "true"
      ? {
          exists: {
            field: this.config.field,
          },
        }
      : {};
  }

  getSelectedFilter(filterSet: any) {
    return {
      type: "ValueSelectedFilter",
      id: `${this.getIdentifier()}_${filterSet.value}`,
      identifier: this.getIdentifier(),
      label: this.config.label,
      value: this.config.field,
      display: this.config.display || "TermFilter",
    };
  }
}

export default ExistFilter;
